import { http_client } from "../../../../plugins/http_client";

const obtenerTodo = async (params) =>
  http_client(
    "/api/configuraciones-adicionales/configuracion-aguinaldo",
    params,
    "get"
  );

const obtenerConfiguracionQuincenaVeinticinco = async () =>
  http_client(
    "/api/configuraciones-adicionales/quincena-veinticinco",
    {},
    "get"
  );

const guardarConfiguracionQuincenaVeinticinco = async (data) =>
  http_client(
    "/api/configuraciones-adicionales/quincena-veinticinco",
    data,
    "put"
  );

const activarTipoAguinaldo = async (params) => {
  const url = `/api/configuraciones-adicionales/configuracion-aguinaldo/${params.id_tipo_aguinaldo}/activar`;
  return http_client(url, {}, "put");
};

const storeAguinaldo = async (params) => {
  const url = `/api/configuraciones-adicionales/configuracion-aguinaldo`;
  return http_client(url, params, "post");
};

const eliminarAguinaldo = async (id) => {
  const url = `/api/configuraciones-adicionales/configuracion-aguinaldo/${id}`;
  return http_client(url, {}, "delete");
};

const obtenerUno = async (id) => {
  const url = `/api/configuraciones-adicionales/configuracion-aguinaldo/${id}`;
  return http_client(url, {}, "get");
};

const guardarEditador = async ({id, data}) => {

  const url = `/api/configuraciones-adicionales/configuracion-aguinaldo/${id}`;
  return http_client(url, data, "put");
};

const obtenerAguinaldosPorEmpleado = async (params) => {
  const url = `/api/gestion-planilla/aguinaldo-por-empleado`;
  return http_client(url, params, "get");
};

const crearAguinaldoPorEmpleado = async (data) => {
  const url = `/api/gestion-planilla/aguinaldo-por-empleado`;
  return http_client(url, data, "post");
};

const actualizarAguinaldoPorEmpleado = async ({ id, data }) => {
  const url = `/api/gestion-planilla/aguinaldo-por-empleado/${id}`;
  return http_client(url, data, "put");
};

const eliminarAguinaldoPorEmpleado = async (id) => {
  const url = `/api/gestion-planilla/aguinaldo-por-empleado/${id}`;
  return http_client(url, {}, "delete");
};

const buscarEmpleado = async ({ search }) => {
  const url = `/api/gestion-planilla/empleado`;
  const params = {
    search,
  };
  return http_client(url, params, "get");
};

const getAnioMes = async (params = {}) => {
  const url = `/api/configuraciones-adicionales/configuracion-aguinaldo/periodo-pago-validacion`;
  return http_client(url, params, "get");
}

const crearPeriodoPago = async (data) => {
  const url = `/api/configuraciones-adicionales/configuracion-aguinaldo/periodo-pago`;
  return http_client(url, data, "post");
}

const editarPeriodoPago = async ({ id, data }) => {
  const url = `/api/configuraciones-adicionales/configuracion-aguinaldo/periodo-pago/${id}`;
  return http_client(url, data, "put");
}

const eliminarPeriodoPago = async (id) => {
  const url = `/api/configuraciones-adicionales/configuracion-aguinaldo/periodo-pago/${id}`;
  return http_client(url, {}, "delete");
}

const obtenerPeriodoPago = async (params) => {
  const url = `/api/configuraciones-adicionales/configuracion-aguinaldo/periodo-pago`;
  return http_client(url, params, "get");
}
export default {
  obtenerTodo,
  activarTipoAguinaldo,
  storeAguinaldo,
  eliminarAguinaldo,
  obtenerUno,
  guardarEditador,
  obtenerAguinaldosPorEmpleado,
  crearAguinaldoPorEmpleado,
  actualizarAguinaldoPorEmpleado,
  eliminarAguinaldoPorEmpleado,
  buscarEmpleado,
  getAnioMes,
  crearPeriodoPago,
  editarPeriodoPago,
  eliminarPeriodoPago,
  obtenerPeriodoPago,
  obtenerConfiguracionQuincenaVeinticinco,
  guardarConfiguracionQuincenaVeinticinco,
};
